// Client/UI state for the auth feature (ARCHITECTURE §6/§37).
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  sessionChecked: false,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    sessionEstablished(state, { payload: user }) {
      state.user = user;
      state.sessionChecked = true;
    },
    sessionCheckFinished(state) {
      state.sessionChecked = true;
    },
    loggedOut() {
      return { ...initialState, sessionChecked: true };
    },
  },
});

export const { sessionEstablished, sessionCheckFinished, loggedOut } = sessionSlice.actions;
export default sessionSlice.reducer;
